import React from 'react';
import { Register } from '../factory';
import { PickerView, Modal } from 'antd-mobile';
import { getLabelByValue } from '../../../service/AddressService';
import { getByLevelAndCode } from '../../../api/dict';

const titleList = {
    degreeType: '选择学位类型',
    categoryCode: '选择门类',
    disciplineCode: '选择学科',
};

const defaultValue = {
    degreeTypeCode: '',
    degreeTypeName: '',
    categoryCode: '',
    categoryName: '',
    disciplineCode: '',
    disciplineName: '',
};

const setValueAndLabel = (list: any[]) => {
    if (!list) {
        return list;
    }
    list.map(item => {
        item.label = item.name;
        item.value = item.code;
        item.id = item.code;
    });
    return list;
};


@Register({ name: 'dy-graduate' })
class DyGraduate extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            degreeTypeList: [], //学位类型列表
            categoryList: [], //门类列表
            disciplineList: [], //学科列表

            degreeTypeVisit: false, //学位类型弹框显示
            categoryCodeVisit: false, //门类弹框显示
            disciplineCodeVisit: false, //学位弹框显示

            ...defaultValue,
        };
    }
    oldValue: any[] = [];

    async componentWillMount() {
        // 初始化学位类型列表
        let {status, result} = await getByLevelAndCode({});
        this.setState({
            degreeTypeList: !status ? setValueAndLabel(result) : [],
        });
    }
    handleCancel = key => {
        const { value } = this.props;
        let newValue = value ? value : defaultValue;
        this.setState(
            {
                ...newValue,
            },
            () => {
                this.props.onChange(value ? value : null);
                this.toggleModalVisit(`${key}Visit`, false);
            }
        );
    };
    toggleModalVisit = (key, value) => {
        this.setState({
            [key]: value,
        });
    };
    handlePickChange = (key, val) => {
        this.setState({
            [`${key}Code`]: val[0],
            [`${key}Name`]: getLabelByValue(this.state[`${key}List`], val[0]),
        });
    };
    // 学位类型确认
    handleDegreeTypeSure = async () => {
        this.toggleModalVisit('degreeTypeVisit', false);
        const { degreeTypeCode } = this.state;
        let {status, result} = await getByLevelAndCode({
            parentCode: degreeTypeCode,
            parentLevel: 1
        });
        this.setState({
            categoryList: !status ? setValueAndLabel(result) : [],
        },()=> {
            this.toggleModalVisit('categoryCodeVisit', true);
        });
    };
    // 门类确认
    handleCategorySure = async () => {
        this.toggleModalVisit('categoryCodeVisit', false);
        const { categoryCode } = this.state;
        let {status, result} = await getByLevelAndCode({
            parentCode: categoryCode,
            parentLevel: 2
        });
        this.setState({
            disciplineList: !status ? setValueAndLabel(result) : [],
        },()=> {
            this.toggleModalVisit('disciplineCodeVisit', true);
        });
    };
    // 学科确认
    handleDisciplineSure = async () => {
        this.toggleModalVisit('disciplineCodeVisit', false);
        const { degreeTypeCode, degreeTypeName, categoryCode, categoryName, disciplineCode, disciplineName } = this.state;
        this.props.onChange({
            degreeTypeCode,
            degreeTypeName,
            categoryCode,
            categoryName,
            disciplineCode,
            disciplineName,
        });
    };

    render() {
        const { 
            degreeTypeList,
            categoryList,
            disciplineList,
            degreeTypeVisit,
            categoryCodeVisit,
            disciplineCodeVisit,
            degreeTypeCode,
            categoryCode,
            disciplineCode
        } = this.state;
        let { className, value } = this.props;
        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                <div
                    className={`dy-fm-item-pick-view ${value && value.degreeTypeName ? 'edited' : ''}`}
                    onClick={() => this.toggleModalVisit('degreeTypeVisit', true)}
                >
                    {value && value.degreeTypeName ? value.degreeTypeName : '请选择学位类型'}
                    {value && value.categoryName ? `/${value.categoryName}` : '/请选择门类'}
                    {value && value.disciplineName ? `/${value.disciplineName}` : '/请选择学科'}
                </div>
                {/* 学位类型 */}
                <Modal popup visible={degreeTypeVisit} onClose={() => this.handleCancel('degreeType')} animationType="slide-up">
                    <div className="am-picker-popup-header">
                        <div className="am-picker-popup-item am-picker-popup-header-left" onClick={() => this.handleCancel('degreeType')}>
                            取消
                        </div>
                        <div className="am-picker-popup-item am-picker-popup-title">{titleList['degreeType']}</div>
                        <div className="am-picker-popup-item am-picker-popup-header-right" onClick={this.handleDegreeTypeSure}>
                            确定
                        </div>
                    </div>
                    <PickerView
                        data={degreeTypeList}
                        value={[degreeTypeCode]}
                        cols={1}
                        onChange={val => this.handlePickChange('degreeType', val)}
                    />
                </Modal>
                {/* 门类 */}
                <Modal popup visible={categoryCodeVisit} onClose={() => this.handleCancel('categoryCode')} animationType="slide-up">
                    <div className="am-picker-popup-header">
                        <div className="am-picker-popup-item am-picker-popup-header-left" onClick={() => this.handleCancel('categoryCode')}>
                            取消
                        </div>
                        <div className="am-picker-popup-item am-picker-popup-title">{titleList['categoryCode']}</div>
                        <div className="am-picker-popup-item am-picker-popup-header-right" onClick={this.handleCategorySure}>
                            确定
                        </div>
                    </div>
                    <PickerView data={categoryList} value={[categoryCode]} cols={1} onChange={val => this.handlePickChange('category', val)} />
                </Modal>
                {/* 学位 */}
                <Modal popup visible={disciplineCodeVisit} onClose={() => this.handleCancel('disciplineCode')} animationType="slide-up">
                    <div className="am-picker-popup-header">
                        <div className="am-picker-popup-item am-picker-popup-header-left" onClick={() => this.handleCancel('disciplineCode')}>
                            取消
                        </div>
                        <div className="am-picker-popup-item am-picker-popup-title">{titleList['disciplineCode']}</div>
                        <div className="am-picker-popup-item am-picker-popup-header-right" onClick={this.handleDisciplineSure}>
                            确定
                        </div>
                    </div>
                    <PickerView data={disciplineList} value={[disciplineCode]} cols={1} onChange={val => this.handlePickChange('discipline', val)} />
                </Modal>
            </div>
        );
    }
}

export default DyGraduate;
